import { VipTaskItemStatusesEnum } from '@shared/constants';

import { VipUserTaskFormValues } from './types';

export const VIP_TASK_ITEM_FORM_INITIAL_VALUES: VipUserTaskFormValues = {
  vipTask: '',
  vipTaskItem: '',
  vipTaskItemStatus: VipTaskItemStatusesEnum.INACTIVE,
};
